module.exports = __webpack_public_path__ + "static/VideoExsis2023-400a1e3652ffe33870bac6ef032cc2c4.mp4";